import type { MapLocation } from './types';

function stringifyAddress(addr: Record<string, unknown> | undefined): string {
  if (!addr) {
    return '';
  }
  const parts: string[] = [];
  for (const v of Object.values(addr)) {
    if (typeof v === 'string' && v.trim() !== '') {
      parts.push(v);
    }
  }
  return parts.join(' ');
}

function stripHtml(html: string): string {
  if (typeof DOMParser === 'undefined') {
    return html.replace(/<[^>]+>/g, ' ');
  }
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent ?? '';
}

/** Lowercased blob for client-side autocomplete (name, map label/address, link URLs/titles). */
export function buildSearchBlob(loc: MapLocation): string {
  const parts: string[] = [loc.name];
  if (loc.map_data.label) {
    parts.push(loc.map_data.label);
  }
  parts.push(stringifyAddress(loc.map_data.tomtom?.address));
  for (const link of loc.links) {
    parts.push(link.url, link.title);
  }
  if (loc.wysiwyg) {
    parts.push(stripHtml(loc.wysiwyg));
  }
  return parts.join(' ').toLowerCase();
}
